module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("官网活动")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学生作品管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "userId"
    },
    model: {
      value: (_vm.queryParam.userId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "userId", $$v)
      },
      expression: "queryParam.userId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "手机号后六位"
    }
  }, [_c('Input', {
    attrs: {
      "name": "cardId"
    },
    model: {
      value: (_vm.queryParam.cardId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "cardId", $$v)
      },
      expression: "queryParam.cardId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('Input', {
    attrs: {
      "name": "nickname"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "作品名称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "title"
    },
    model: {
      value: (_vm.queryParam.title),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "title", $$v)
      },
      expression: "queryParam.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "所属赛区"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.competitionArea),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "competitionArea", _vm._n($$v))
      },
      expression: "queryParam.competitionArea"
    }
  }, _vm._l((_vm.$constant.competitionAreaEnum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄分组"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.ageGroup),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ageGroup", _vm._n($$v))
      },
      expression: "queryParam.ageGroup"
    }
  }, _vm._l((_vm.$constant.ageGroupEnum), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('Col', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "goNextPhase"
    },
    on: {
      "click": _vm.goNextPhase
    }
  }, [_vm._v("进入下一阶段")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/safenessUserVideo/pageList",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('EditUserVideoModal', {
    attrs: {
      "value": _vm.showEditUserVideoModal,
      "itemId": _vm.itemId,
      "successCallback": _vm.search
    },
    on: {
      "on-close": function($event) {
        _vm.showEditUserVideoModal = false
      },
      "on-edit-clearid": _vm.clearid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9c39e60","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/safenessVote/UserVideoList.vue
// module id = 1995
// module chunks = 8